<!-- 选择老师 -->
<template>
  <el-form-item :label="label">
    <yx-teacher-selector
      v-bind="config"
      @select="select"
      ref="child"
      @clear="clear"
      width="222px"
    />
  </el-form-item>
</template>

<script>
import { inject, onMounted, ref } from 'vue';

export default {
  kind: 'yq-老师选择',
  props: {
    // 初始值.
    value: {
      type: [Array, String, Number, Object],
      default: () => ({}),
    },
    config: {
      type: Object,
      default() {
        return {
          multiple: true,
        };
      },
    },
    label: {
      type: String,
      default: '老师：',
    },
  },
  setup(props) {
    const child = ref(null);
    const useQuery = inject('useQuery');

    function clear() {
      // eslint-disable-next-line no-use-before-define
      teacher.value = {};
      child.value.clearField();
    }
    function reset() {
      // eslint-disable-next-line no-use-before-define
      teacher.value = props.value;
      if (props.value.id) {
        child.value.setField(props.value.name);
      } else {
        child.value.clearField();
      }
    }
    const teacher = useQuery('teacher', props.value, reset);

    if (props.value.id) {
      onMounted(() => {
        child.value.setField(props.value.name);
      });
    }

    function select(obj) {
      teacher.value = obj;
    }

    return {
      select,
      child,
      clear,
    };
  },
};
</script>
